const indianStatesAndCities = {
 "Andaman and Nicobar Islands": [
    "Aberdeen Bazaar", "Bakultala", "Bambooflat", "Billiground", "Campbell Bay", "Car Nicobar",
    "Chowra", "Chouldari", "Diglipur", "Garacharma", "Haddo", "Kadamtala", "Kamorta",
    "Kanchan", "Katchal", "Little Nicobar", "Mayabunder", "Minnie Bay", "Pillowmillow",
    "Port Blair", "Prothrapur", "Rangat", "Shadipur", "Teressa", "Wandoor"
  ],
  "Andhra Pradesh": [
    "Addanki", "Adoni", "Allagadda", "Amadalavalasa", "Amalapuram", "Anakapalli", "Anantapur", 
    "Atmakur", "Avanigadda", "Badvel", "Banaganapalle", "Bapatla", "Bheemunipatnam", "Bhimadole", 
    "Bhimavaram", "Bobbili", "Cheepurupalli", "Chilakaluripet", "Chintapalle", "Chirala", 
    "Chittoor", "Chodavaram", "Darsi", "Denduluru", "Dharmavaram", "Dhone", "Eluru", 
    "Gajapathinagaram", "Gajuwaka", "Giddalur", "Gudivada", "Gudur", "Gummalakshmipuram", 
    "Guntakal", "Guntur", "Hindupur", "Ichchapuram", "Jaggayyapeta", "Jammalamadugu", 
    "Kadapa", "Kadiri", "Kakinada", "Kalyandurg", "Kamalapuram", "Kanchikacherla", "Kandukur", 
    "Kaikaluru", "Kavali", "Kothapeta", "Komarada", "Kovvur", "Kurupam", "Kurnool", "Little Nicobar", 
    "Machilipatnam", "Macherla", "Madakasira", "Madanapalle", "Makkulapeta", "Mandalapeta", 
    "Mandapeta", "Maredumilli", "Mayabunder", "Minnie Bay", "Mummidivaram", "Mylavaram", 
    "Naidupet", "Nandigama", "Nandikotkur", "Nandyal", "Narasaraopet", "Narasapuram", 
    "Narsipatnam", "Nellore", "Nuzvid", "Ongole", "Padapeta", "Paderu", "Palakollu", 
    "Palakonda", "Palamaner", "Peddapuram", "Pedana", "Penukonda", "Piduguralla", "Pileru", 
    "Pithapuram", "Pokkadera", "Ponnur", "Port Blair", "Prathipadu", "Proddatur", "Prothrapur", 
    "Pulivendula", "Punganur", "Puttaparthi", "Puttur", "Rajahmundry", "Rajampet", "Rajavommangi", 
    "Rajam", "Ramachandrapuram", "Rampachodavaram", "Rangareddy", "Rayachoti", "Rayadurg", 
    "Ravulapalem", "Repalle", "Salur", "Samalkot", "Sattenapalle", "Shadipur", "Srikakulam", 
    "Srikalahasti", "Tadepalligudem", "Tadipatri", "Tanuku", "Tenali", "Teressa", "Tirupati", 
    "Tiruvuru", "Tuni", "Uravakonda", "Venkatagiri", "Vijayawada", "Vinukonda", "Visakhapatnam", 
    "Vizianagaram", "Vuyyuru", "Yatapaka", "Yelamanchili", "Yemmiganur"
  ]
,  "Arunachal Pradesh": [
  "Aalo", "Anini", "Balijan", "Bameng", "Baririjo", "Basar", "Bichom", "Boleng", "Bomdila", "Bordumsa",
  "Chaglagam", "Chambang", "Changlang", "Chayangtajo", "Chongkham", "Chowkham", "Dambuk", "Damin",
  "Daporijo", "Daring", "Deed", "Deomali", "Dirang", "Doimukh", "Dollungmukh", "Dumporijo", "Etalin",
  "Geku", "Gensi", "Goiliang", "Hapoli", "Hawai", "Hayuliang", "Hunli", "Jairampur", "Jamin", "Jang",
  "Jengging", "Kanubari", "Kamba", "Kaying", "Kharsang", "Khonsa", "Kibithoo", "Kimin", "Koloriang",
  "Koronu", "Kora", "Kurung Kumey", "Lada", "Lathao", "Lazu", "Lekang", "Likabali", "Longding", "Lumla",
  "Manchal", "Mariyang", "Mebo", "Mechuka", "Metengliang", "Miao", "Mipi", "Monigong", "Nacho",
  "Nafta", "Nampong", "Namsai", "Nari", "Nyapin", "Pakke-Kessang", "Palin", "Pangin", "Paramputu",
  "Pasighat", "Pedi", "Pidi", "Pipu", "Pistana", "Puchi-Geko", "Pumao", "Raga", "Roing", "Ruksin",
  "Rumgong", "Rupa", "Sago", "Sagalee", "Sangram", "Sarli", "Seijosa", "Seppa", "Sirilang", "Soha",
  "Sunpura", "Tali", "Tawang", "Tato", "Tezu", "Telam", "Tenga", "Thrizino", "Tuting", "Vijoynagar",
  "Wakka", "Walong", "Yachuli", "Yazali", "Yingkiong", "Yupia", "Zemithang", "Ziro"
]
,
  "Assam": [
  "Abhayapuri", "Algapur", "Amguri", "Amingaon", "Amoni", "Badarpur", "Baihata Chariali", "Baithalangso",
  "Balijana", "Barama", "Barbhag", "Barpeta", "Barpeta Road", "Basugaon", "Behali", "Bhawaniour",
  "Bhowraguri", "Bihpuria", "Bijni", "Bilasipara", "Biswanath Chariali", "Bokajan", "Bokakhat", 
  "Chabua", "Chapar", "Charaideo", "Chaygaon", "Dalgaon", "Darangamela", "Demow", "Dergaon",
  "Dhaligaon", "Dhekiajuli", "Dhemaji", "Dhing", "Dhubri", "Dibrugarh", "Digboi", "Diphu", "Dispur",
  "Doboka", "Dokmoka", "Donkamokam", "Doom Dooma", "Dudhnoi", "Fekamari", "Garmur", "Gauripur",
  "Ghograpar", "Goalpara", "Gohpur", "Golaghat", "Golokganj", "Goreswar", "Gossaigaon", "Guwahati",
  "Haflong", "Hailakandi", "Hajo", "Hamren", "Harisinga", "Harmoti", "Hatsingimari", "Helem", "Hojai",
  "Howli", "Howraghat", "Jagiroad", "Jengraimukh", "Jogighopa", "Jorhat", "Kajalgaon", "Kaliapani",
  "Kaliabor", "Kamjan", "Kampur", "Karimganj", "Khanapara", "Kheroni", "Khowang", "Kokrajhar",
  "Laharighat", "Lakhipur", "Lala", "Langting", "Lanka", "Lumding", "Maibang", "Mahmora", "Mahur",
  "Majuli", "Makum", "Maligaon", "Mangaldoi", "Mankachar", "Margherita", "Mariani", "Matia",
  "Mayong", "Mazbat", "Mikirbheta", "Moran", "Morigaon", "Mushalpur", "Naharkatia", "Nagaon",
  "Nagarbera", "Nagrijuli", "Nalbari", "Narayanpur", "Nazira", "Niz-Bahjani", "Numaligarh", "Palashbari",
  "Panikhaiti", "Patacharkuchi", "Patharkandi", "Patharighat", "Pathsala", "Raha", "Ramkrishna Nagar",
  "Rangapara", "Rangia", "Ratabari", "Runikhata", "Salakati", "Salamara", "Salbari", "Sapatgram",
  "Sarthe", "Sarthebari", "Sarupathar", "Sarupeta", "Sidli", "Silapathar", "Silchar", "Sipajhar",
  "Sonai", "Sonari", "Sorkhret", "Sorbhog", "South Salmara", "Sotea", "Suffry", "Sukhchar", "Suklai",
  "Tamulpur", "Tangla", "Teok", "Tezpur", "Tihu", "Tinsukia", "Titabor", "Udalguri", "Udarbond",
  "Umrangso", "West Karbi Anglong"
]
,
  "Bihar":[
  "Alamnagar", "Alauli", "Amarpur", "Araria", "Areraj", "Ariari", "Arrah", "Arwal", "Asarganj", "Aurangabad",
  "Bachhwara", "Bagaha", "Bahadurganj", "Bahadurpur", "Bairgania", "Bakhri", "Balia", "Banka", "Banmankhi", "Barahiya",
  "Barbigha", "Barh", "Barharia", "Barsoi", "Bausi", "Behea", "Begusarai", "Beldaur", "Belhar", "Belsand",
  "Belsar", "Benipatti", "Benipur", "Bettiah", "Bhabua", "Bhagalpur", "Bhojpur", "Bihar Sharif", "Bihariganj", "Bikramganj",
  "Birpur", "Bochahan", "Bodh Gaya", "Buxar", "Chainpur", "Chapra", "Chanpatia", "Chakia", "Chewara", "Colgong",
  "Dalsinghsarai", "Danapur", "Darbhanga", "Daudnagar", "Dehri", "Dhamdaha", "Dhaka", "Dighalbank", "Dighwara", "Dumra",
  "Dumraon", "Dumri Katsari", "Forbesganj", "Gaya", "Garhpura", "Ghailarh", "Ghoshi", "Gogri", "Goh", "Gopalganj",
  "Hajipur", "Harnaut", "Hathua", "Hilsa", "Hisua", "Hulasganj", "Islampur", "Itarhi", "Jagdispur", "Jainagar",
  "Jamalpur", "Jamui", "Jale", "Jehanabad", "Jhajha", "Jhanjharpur", "Jogbani", "Kaimur", "Kaler", "Kanti",
  "Karpi", "Kasba", "Katihar", "Katoria", "Keoti", "Khagaria", "Kharagpur", "Kishanganj", "Kochadhaman", "Kuchaikote",
  "Kurhani", "Kurtha", "Lakhisarai", "Lakhminia", "Lalganj", "Mahishi", "Mahnar Bazar", "Mahua", "Makhdumpur", "Mairwa",
  "Manihari", "Mansurchak", "Marhaura", "Masaurhi", "Matihani", "Madhubani", "Mirganj", "Mohania", "Motihari", "Muzaffarpur",
  "Munger", "Murliganj", "Nabinagar", "Narkatiaganj", "Narpatganj", "Naugachia", "Nawada", "Nirmali", "Nokha", "Pakribarawan",
  "Parbatta", "Paroo", "Patna", "Patori", "Phulparas", "Phulwari Sharif", "Piprahi", "Pipariya", "Piro", "Pupri",
  "Purnia", "Rajgir", "Rajpur", "Raghopur", "Rafiganj", "Rajauli", "Ramgarh", "Ramnagar", "Raniganj", "Rautara",
  "Ratni Faridpur", "Raxaul", "Revelganj", "Rohtas", "Rosera", "Rupauli", "Sabour", "Saharsa", "Sahebpur Kamal", "Sahibganj",
  "Sangrampur", "Samastipur", "Saran", "Sasaram", "Shahpur", "Shamho Akha Kurha", "Sheikhpura", "Shekhopur Sarai", "Sheohar", "Sherghati",
  "Sikandra", "Simri", "Simri Bakhtiyarpur", "Singheshwar", "Singhwara", "Sitamarhi", "Sono", "Sonbarsa", "Sonpur", "Sugauli",
  "Sultanganj", "Supaul", "Surajgarha", "Suryapur", "Tajpur", "Tarapur", "Tariani Chowk", "Tekari", "Teghra", "Thawe",
  "Thakurganj", "Triveniganj", "Vaishali", "Warisaliganj", "Wazirganj", "Ziradei"
]
,
  "Chandigarh": ["Chandigarh"],
  "Chhattisgarh":[
  "Adbhar", "Ahiwara", "Akaltara", "Ambagarh Chowki", "Ambikapur", "Ama Seoni", "And", "Arang", "Bagbahara", "Baghera",
  "Baikunthpur", "Balod", "Baloda Bazar", "Balrampur", "Baradwar", "Basna", "Bastar", "Beltara", "Bemetara", "Berla",
  "Bhaiyathan", "Bhatgaon", "Bhatapara", "Bhanupratappur", "Bhilai", "Bhothiya", "Bilaigarh", "Bilaspur", "Birgaon",
  "Bishrampur", "Champa", "Chandrapur", "Charoda", "Charcha", "Chhuikhadan", "Chhura", "Chirmiri", "Dabhra", "Daldal Seoni",
  "Dalli-Rajhara", "Dantewada", "Deobhog", "Dhamdha", "Dhamtari", "Dharsiwa", "Dharamjaigarh", "Dipka", "Dondi", "Dondi Lohara",
  "Dongargaon", "Dongargarh", "Durg", "Fingeshwar", "Gaurella", "Gariaband", "Gharghora", "Hasaud", "Jagdalpur", "Jaijaipur",
  "Jamul", "Janjgir", "Jashpur Nagar", "Kasdol", "Katghora", "Kawardha", "Kendri", "Khairagarh", "Kharsia", "Khongapani",
  "Kharora", "Konta", "Kondagaon", "Korea", "Korba", "Kumhari", "Kunkuri", "Kurud", "Lormi", "Mahasamund", "Mainpur",
  "Malkharouda", "Mana", "Mana Camp", "Manendragarh", "Manpur", "Marwahi", "Masturi", "Mohla", "Mowa", "Mungeli",
  "Nagri", "Narayanpur", "Nardaha", "Navagarh", "Naya Raipur", "Odagi", "Palari", "Pandariya", "Pandatarai", "Pali",
  "Pathalgaon", "Pathariya", "Patan", "Pendra", "Pithora", "Pratappur", "Prem Nagar", "Raigarh", "Raipur", "Rajnandgaon",
  "Ramanujganj", "Ramanujnagar", "Ratanpur", "Risali", "Rismara", "Saddu", "Saja", "Sakti", "Saraipali", "Sarangarh",
  "Sarona", "Sejbahar", "Siltara", "Simga", "Sitapur", "Sonhat", "Supela", "Surajpur", "Sukma", "Takhatpur", "Tatibandh",
  "Tilda", "Utai"
]
,
  "Dadra and Nagar Haveli and Daman and Diu": [
  "Amli", "Bhimpore", "Bucharwada", "Dabhel", "Daman", "Diu", "Ghoghla", "Kadaiya", "Masat", "Naroli", 
  "Rakholi", "Randha", "Samarvarni", "Silvassa", "Simbor", "Vanakbara", "Varkund"
],
  "Delhi":[
  "Ashok Vihar", "Bhajanpura", "Chanakyapuri", "Civil Lines", "Connaught Place", "Daryaganj", "Defence Colony",
  "Dilshad Garden", "Dwarka", "East of Kailash", "Gandhi Nagar", "GK", "Gokalpur", "Greater Kailash",
  "GTB Enclave", "Hauz Khas", "Janakpuri", "Jahangirpuri", "Jhilmil Colony", "Kalkaji", "Kamla Market",
  "Karawal Nagar", "Karol Bagh", "Lado Sarai", "Lajpat Nagar", "Laxmi Nagar", "Lodhi Colony", "Mahipalpur",
  "Malviya Nagar", "Mayur Vihar", "Mehrauli", "Model Town", "Mukherjee Nagar", "Najafgarh", "Nehru Place",
  "Netaji Subhash Place", "Palam", "Paharganj", "Paschim Vihar", "Patel Nagar", "Pitampura", "Preet Vihar",
  "Punjabi Bagh", "Rajouri Garden", "RK Puram", "Rohini", "Sadar Bazar", "Saket", "Sarojini Nagar", "Seelampur",
  "Seemapuri", "Shahdara", "Shalimar Bagh", "Subhash Nagar", "Timarpur", "Tilak Nagar", "Tughlakabad",
  "Uttam Nagar", "Vasant Kunj", "Vasant Vihar", "Vishwas Nagar", "Vivek Vihar", "Yamuna Vihar"
]
,
  "Goa":[
  "Aldona", "Bicholim", "Calangute", "Candolim", "Canacona", "Cavelossim", "Chinchinim", "Colva", "Cuncolim",
  "Margao", "Mapusa", "Mormugao", "Panaji", "Pernem", "Ponda", "Porvorim", "Quepem", "Sanquelim", "Sancoale",
  "Siolim", "Tivim", "Valpoi", "Vasco da Gama"
]
,
  "Gujarat": [
  "Ahmedabad", "Ahwa", "Amreli", "Anand", "Anjar", "Ankleshwar", "Babra", "Bagasara", "Balasinor",
  "Bardoli", "Bayad", "Bhachau", "Bharuch", "Bhavnagar", "Bhiloda", "Bhuj", "Bilimora", "Bodeli",
  "Borsad", "Botad", "Chhota Udaipur", "Chikhli", "Chorasi", "Chotila", "Dabhoi", "Dahod",
  "Damnagar", "Dediapada", "Deesa", "Dehgam", "Devgadh Baria", "Dhanera", "Dharampur", "Dholka",
  "Dhoraji", "Dhrangadhra", "Dwarka", "Gadhada", "Gandevi", "Gandhidham", "Gandhinagar", "Gariadhar",
  "Godhra", "Gondal", "Halol", "Halvad", "Harij", "Himmatnagar", "Idar", "Jafrabad", "Jambusar",
  "Jamnagar", "Jasdan", "Jetpur", "Junagadh", "Kadi", "Kalavad", "Kalol", "Kamrej", "Kapadvanj",
  "Karjan", "Kawant", "Keshod", "Khambhalia", "Khambhat", "Kheda", "Khedbrahma", "Kodinar",
  "Kutiyana", "Lathi", "Liliya", "Limbdi", "Limkheda", "Lunawada", "Mahudha", "Mahuva", "Manavadar",
  "Mandvi", "Mansa", "Mehsana", "Mendarda", "Modasa", "Morbi", "Mundra", "Nadiad", "Navsari",
  "Olpad", "Padra", "Palanpur", "Palitana", "Pardi", "Patan", "Petlad", "Porbandar", "Prantij",
  "Radhanpur", "Rajkot", "Rajpipla", "Rajula", "Ranavav", "Sagbara", "Sanand", "Sankheswar",
  "Santrampur", "Saraswati", "Savarkundla", "Savli", "Shamlaji", "Shehera", "Siddhpur", "Sihor",
  "Songadh", "Surat", "Surendranagar", "Talaja", "Talod", "Tankara", "Thangadh", "Tharad",
  "Umarpada", "Umbergaon", "Umreth", "Una", "Unjha", "Upleta", "Vadodara", "Valsad", "Vanthali",
  "Vapi", "Veraval", "Vijapur", "Viramgam", "Virpur", "Visavadar", "Visnagar", "Vyara", "Wadhwan",
  "Waghai", "Wankaner", "Zalod"
]
,
  "Haryana": [
  "Adampur", "Ambala", "Ambala Cantt", "Ambala City", "Assandh", "Ateli", "Bahadurgarh", "Ballabgarh",
  "Barara", "Barwala", "Bawani Khera", "Bawani Khera", "Beri", "Bhuna", "Bhiwani", "Bilaspur", "Charkhi Dadri",
  "Chhachhrauli", "Dabwali", "Dharuhera", "Ellenabad", "Faridabad", "Fatehabad", "Ferozepur Jhirka", "Ganaur",
  "Gharaunda", "Gohana", "Guhla", "Hansi", "Hathin", "Hisar", "Hodal", "Indri", "Israna", "Jagadhri", "Jind",
  "Jhajjar", "Julana", "Kaithal", "Kalanaur", "Kalayat", "Kalka", "Kanina", "Karnal", "Kosli", "Ladwa",
  "Loharu", "Mahendragarh", "Maham", "Majalta", "Matanhail", "Mulana", "Nagina", "Naraingarh", "Narnaund",
  "Narnaul", "Narwana", "Natar", "Nilokheri", "Nuh", "Palwal", "Panchkula", "Panipat", "Pataudi",
  "Pehowa", "Pinjore", "Punahana", "Pundri", "Raipur Rani", "Radaur", "Rajound", "Rania", "Rewari", "Rohtak",
  "Sadhaura", "Saha", "Safidon", "Samalkha", "Sampla", "Shahbad", "Shahzadpur", "Siwani", "Sohna", "Sonipat",
  "Taraori", "Taoru", "Thanesar", "Tohana", "Tosham", "Uchana", "Uklana Mandi", "Yamunanagar"
]
,
  "Himachal Pradesh": [
  "Amb", "Arki", "Baddi", "Baijnath", "Banjar", "Banikhet", "Bhoranj", "Bhuntar", "Bilaspur", "Chamba",
  "Chaupal", "Dalhousie", "Gagret", "Ghumarwin", "Hamirpur", "Jogindernagar", "Kalpa", "Kangra", "Kaza",
  "Keylong", "Kullu", "Manali", "Mandi", "Nadaun", "Nahan", "Naina Devi", "Nalagarh", "Nichar", "Palampur",
  "Paonta Sahib", "Parwanoo", "Pooh", "Rajgarh", "Rampur", "Reckong Peo", "Rohru", "Sangrah", "Sarkaghat",
  "Shimla", "Solan", "Sujanpur Tira", "Sundernagar", "Tabo", "Theog", "Tissa", "Una"
]
,
  "Jammu and Kashmir":[
  "Achabal", "Akhnoor", "Anantnag", "Arnas", "Atholi", "Awantipora", "Bandipora", "Banihal", "Baramulla",
  "Basohli", "Batote", "Beerwah", "Bhaderwah", "Bijbehara", "Bishnah", "Budgam", "Chenani", "Chadoora",
  "Dal Lake", "Devsar", "Doda", "Ganderbal", "Gandoh", "Ghagwal", "Hajin", "Handwara", "Harwan",
  "Hiranagar", "Jammu", "Kalakote", "Kangan", "Karnah", "Kathua", "Katra", "Keller", "Khan Sahib",
  "Kishtwar", "Kokernag", "Kupwara", "Ladwa", "Lakhanpur", "Lar", "Magam", "Mahore", "Majalta",
  "Marwah", "Mendhar", "Mughal Maidan", "Nagrota", "Nagina", "Nowshera", "Pahalgam", "Pampore", "Patan",
  "Pattan", "Pooh", "Pulwama", "Qazigund", "Rajouri", "Ramnagar", "Ramban", "Rainawari", "Ramgarh",
  "Reasi", "Samba", "Shopian", "Sopore", "Srinagar", "Sumbal", "Sunderbani", "Surankote", "Tangdhar",
  "Tangmarg", "Thathri", "Tral", "Tullamulla", "Uri", "Udhampur", "Vijaypur", "Yaripora", "Zainapora"
]
,
  "Jharkhand": [
  "Arki", "Balumath", "Barhi", "Barkagaon", "Barkakana", "Bermo", "Bhandra", "Bokaro Steel City", "Bundu", "Chaibasa", "Chakradharpur", "Chandil", "Chandrapura", "Chas", "Chatra", "Deoghar", "Dhanbad", "Dhanwar", "Dumka", "Ghatshila", "Giridih", "Godda", "Gumla", "Hazaribagh", "Hunterganj", "Itkhori", "Jamshedpur", "Jamtara", "Jasidih", "Jharia", "Kandra", "Katkamsandi", "Katras", "Khunti", "Koderma", "Kuchai", "Latehar", "Lohardaga", "Madhupur", "Manoharpur", "Musabani", "Noamundi", "Phusro", "Potka", "Ramgarh", "Ranchi", "Sahibganj", "Saraikela", "Simaria", "Simdega", "Sindri", "Tamar", "Torpa"
],
  "Karnataka": [
  "Afzalpur", "Aland", "Alur", "Ankola", "Arsikere", "Athani", "Aurad", "Bagepalli", "Bagalkot", "Bailhongal", "Ballari", "Bangarapet", "Bantwal", "Basavakalyan", "Basavana Bagewadi", "Belagavi", "Belthangady", "Bengaluru", "Bhadravati", "Bhalki", "Bhatkal", "Bidar", "Bilgi", "Byadgi", "Challakere", "Chamarajanagar", "Channagiri", "Channarayapatna", "Chikballapur", "Chikkamagaluru", "Chikkanayakanahalli", "Chikodi", "Chincholi", "Chintamani", "Chitradurga", "Dandeli", "Davanagere", "Devanahalli", "Dharwad", "Doddaballapura", "Gadag", "Gangavathi", "Gauribidanur", "Gokak", "Gubbi", "Gudibanda", "Guledgudda", "Hagaribommanahalli", "Haliyal", "Hangal", "Harapanahalli", "Harihar", "Hassan", "Haveri", "Hiriyur", "Holalkere", "Holenarasipura", "Honnali", "Hosadurga", "Hosapete", "Hoskote", "Hubballi", "Hukkeri", "Hungund", "Hunsur", "Ilkal", "Indi", "Jagalur", "Jamkhandi", "Jevargi", "Kadur", "Kalaburagi", "Kalghatgi", "Kampli", "Kanakapura", "Karkala", "Karwar", "Khanapur", "Kodagu", "Kolar", "Kollegal", "Koppa", "Koppal", "Koratagere", "Kotturu", "Krishnarajpet", "Krishnarajanagara", "Kudligi", "Kumta", "Kundapura", "Kundgol", "Kunigal", "Kushtagi", "Lingsugur", "Madikeri", "Madhugiri", "Magadi", "Malavalli", "Malur", "Mandya", "Mangaluru", "Manvi", "Mudalgi", "Muddebihal", "Mudhol", "Mulbagal", "Mundargi", "Mysuru", "Nagar Untari", "Nagamangala", "Nanjangud", "Nargund", "Navalgund", "Nelamangala", "Nippani", "Nyamati", "Pandavapura", "Pavagada", "Piriyapatna", "Puttur", "Rabkavi Banhatti", "Raichur", "Ramanagara", "Ramdurg", "Ranebennur", "Raybag", "Ron", "Sagar", "Sakleshpur", "Sandur", "Sankeshwar", "Saundatti", "Sedam", "Shahapur", "Shiggaon", "Shikaripura", "Shirhatti", "Shivamogga", "Shorapur", "Shrirangapattana", "Sidlaghatta", "Sindagi", "Sindhanur", "Sirsi", "Sira", "Siruguppa", "Someshwara", "Somwarpet", "Soraba", "Sringeri", "Srinivaspur", "Sullia", "Tarikere", "Tekkalakote", "Terdal", "Thirthahalli", "Tiptur", "Tirumakudal Narsipur", "Tumakuru", "Turuvekere", "Udupi", "Ullal", "Virajpet", "Yadgir", "Yelburga", "Yelandur"
],
  "Kerala": [
  "Adoor", "Alappuzha", "Aluva", "Angamaly", "Attingal", "Chalakudy", "Changanassery", "Chavakkad", "Cherthala", "Ernakulam", "Guruvayur", "Haripad", "Idukki", "Irinjalakuda", "Kalpetta", "Kannur", "Kanhangad", "Kasaragod", "Kattappana", "Kayamkulam", "Kochi", "Kodungallur", "Kollam", "Kottarakkara", "Kottayam", "Koyilandy", "Kozhikode", "Kunnamkulam", "Malappuram", "Mananthavady", "Manjeri", "Mavelikkara", "Muvattupuzha", "Nedumangad", "Nedumkandam", "Neyyattinkara", "Nilambur", "Ottappalam", "Palakkad", "Pala", "Panamuk", "Pathanamthitta", "Payyannur", "Perinthalmanna", "Perumbavoor", "Ponnani", "Punalur", "Shoranur", "Sultan Bathery", "Taliparamba", "Thalassery", "Thiruvalla", "Thiruvananthapuram", "Thodupuzha", "Thrissur", "Tirur", "Vadakara", "Vaikom", "Varkala"
],
  "Ladakh": [
  "Achinathang", "Alchi", "Barsoo", "Basgo", "Bogdang", "Chalunka", "Changmar", "Choglamsar", "Chumathang", "Chushul", "Diskit", "Domkhar", "Drass", "Dungti", "Garkone", "Hanle", "Hemis", "Hunder", "Kaksar", "Kargil", "Karu", "Karsha", "Korzok", "Leh", "Likir", "Loma", "Manali", "Matayan", "Merak", "Minamarg", "Muney", "Nyoma", "Padum", "Panamik", "Pandras", "Phey", "Raru", "Rongo", "Sani", "Saspol", "Shey", "Shargole", "Silmo", "Spituk", "Stok", "Stongdey", "Sumur", "Tangtse", "Thiksey", "Tingmosgang", "Trespone", "Tungri", "Turtuk", "Uleytokpo", "Upshi", "Zangla"
],
  "Lakshadweep": [
  "Agatti", "Amini", "Andrott", "Bitra", "Chetlat", "Kadmat", "Kalpeni", "Kavaratti", "Kiltan", "Minicoy"
],
  "Madhya Pradesh":[
  "Agar", "Ajaigarh", "Amarpur", "Ambah", "Amla", "Anjad", "Anuppur", "Arone", "Ashoknagar", "Ashta", "Ater", "Babai", "Badarwas", "Badnagar", "Badod", "Bada Malhera", "Bagli", "Baihar", "Balaghat", "Baldeogarh", "Bamhni Banjar", "Banda", "Bareli", "Barghat", "Barhi", "Barwani", "Basoda", "Batiyagarh", "Beohari", "Berasia", "Betul", "Bhabra", "Bhander", "Bhanpura", "Bhikangaon", "Bhind", "Bhopal", "Biaora", "Bijawar", "Bijuri", "Bina", "Burhanpur", "Chachaura", "Chanderi", "Chandia", "Chhatarpur", "Chhindwara", "Chicholi", "Chitrakoot", "Churhat", "Dabra", "Damoh", "Datia", "Deosar", "Depalpur", "Devendranagar", "Dewas", "Dhamnod", "Dhanpuri", "Dhar", "Dindori", "Gadarwara", "Gairatganj", "Garoth", "Ghansaur", "Ghughri", "Gogawan", "Gohad", "Guna", "Gwalior", "Handia", "Harda", "Harsud", "Hata", "Hatta", "Hatod", "Hoshangabad", "Ichhawar", "Indergarh", "Indore", "Isagarh", "Jabalpur", "Jaisinghnagar", "Jaithari", "Jaitpur", "Jawad", "Jhabua", "Jobat", "Joura", "Kailaras", "Kannod", "Karanjia", "Karera", "Karhal", "Katangi", "Katni", "Khachrod", "Khajuraho", "Khandwa", "Khargone", "Khategaon", "Khetia", "Khilchipur", "Khirkiya", "Khurai", "Kolaras", "Kotma", "Kukshi", "Kundam", "Lahar", "Lakhnadon", "Machalpur", "Maihar", "Majhauli", "Majhgawan", "Maksi", "Malhargarh", "Manasa", "Mandla", "Mandsaur", "Manpur", "Mauganj", "Mhow", "Morena", "Multai", "Mungaoli", "Nagda", "Nagod", "Nainpur", "Narsinghgarh", "Narsinghpur", "Nasrullaganj", "Nateran", "Neemuch", "Nepanagar", "Nowgong", "Nowrozabad", "Obedullaganj", "Pachmarhi", "Pali", "Pandhana", "Pandhurna", "Panna", "Pansemal", "Patan", "Patharia", "Pawai", "Petlawad", "Pichhore", "Pipariya", "Piprai", "Porsa", "Prithvipur", "Punasa", "Pushprajgarh", "Raghogarh", "Rahatgarh", "Raisen", "Rajgarh", "Rajpur", "Ratlam", "Rehli", "Rewa", "Rithi", "Sagar", "Sailana", "Sanwer", "Sarangpur", "Sardarpur", "Satna", "Sausar", "Sehore", "Seondha", "Seoni", "Shahdol", "Shahgarh", "Shahpura", "Shajapur", "Sheopur", "Shivpuri", "Shujalpur", "Sidhi", "Sihawal", "Sihora", "Silwani", "Singrauli", "Singoli", "Sirmour", "Sironj", "Sohagpur", "Sonkatch", "Susner", "Tamia", "Tarana", "Tendukheda", "Teonthar", "Thandla", "Tikamgarh", "Timarni", "Udaigarh", "Ujjain", "Umaria", "Unchehara", "Vidisha", "Vijaypur", "Waraseoni", "Waidhan"
],
  
  "Maharashtra": [
    "Achalpur",
    "Ahilyanagar",
    "Ahmednagar",
    "Ahmedpur",
    "Aheri",
    "Ajara",
    "Akkalkot",
    "Akkalkuwa",
    "Akola",
    "Akot",
    "Alibag",
    "Amalner",
    "Ambad",
    "Ambarnath",
    "Ambejogai",
    "Ambegaon",
    "Amravati",
    "Anjangaon Surji",
    "Ardhapur",
    "Armori",
    "Arni",
    "Aronda",
    "Arvi",
    "Ashti",
    "Ashti",
    "Atpadi",
    "Aundha Nagnath",
    "Ausa",
    "Badlapur",
    "Badnapur",
    "Baglan",
    "Balapur",
    "Ballarpur",
    "Balimela",
    "Bandra",
    "Baramati",
    "Barshi",
    "Barshitakli",
    "Basmath",
    "Beed",
    "Bhadgaon",
    "Bhadravati",
    "Bhamragad",
    "Bhandara",
    "Bhandup",
    "Bhiwandi",
    "Bhiwapur",
    "Bhokar",
    "Bhokardan",
    "Bhor",
    "Bhudargad",
    "Bhusawal",
    "Biloli",
    "Bodvad",
    "Borgaon",
    "Borivali",
    "Bramhapuri",
    "Buldhana",
    "Byculla",
    "Chakur",
    "Chalisgaon",
    "Chamorshi",
    "Chandgad",
    "Chandrapur",
    "Chandur Bazar",
    "Chandur Railway",
    "Chhatrapati Sambhajinagar",
    "Chikhaldara",
    "Chikhli",
    "Chiplun",
    "Chitrakonda",
    "Chopda",
    "Churchgate",
    "Colaba",
    "Dadar",
    "Dahanu",
    "Dapoli",
    "Daryapur",
    "Darwha",
    "Daund",
    "Deglur",
    "Deoli",
    "Deoni",
    "Desaiganj",
    "Deulgaon Raja",
    "Devgad",
    "Dhadgaon",
    "Dhamangaon Railway",
    "Dhanora",
    "Dharangaon",
    "Dharashiv",
    "Dharmabad",
    "Dharur",
    "Dharni",
    "Dhule",
    "Digras",
    "Dindori",
    "Erandol",
    "Etapalli",
    "Fort",
    "Gadchiroli",
    "Gadhinglaj",
    "Gaganbawada",
    "Gangakhed",
    "Gangapur",
    "Gevrai",
    "Ghatak",
    "Ghatanji",
    "Ghatkopar",
    "Ghansawangi",
    "Girgaon",
    "Gondia",
    "Gondpipri",
    "Goregaon",
    "Goregaon",
    "Guhagar",
    "Hadgaon",
    "Hatkanangale",
    "Haveli",
    "Hedul",
    "Hinganghat",
    "Hingna",
    "Hingoli",
    "Ichalkaranji",
    "Igatpuri",
    "Indapur",
    "Jafrabad",
    "Jalgaon",
    "Jalgaon Jamod",
    "Jalkot",
    "Jalna",
    "Jamkhed",
    "Jamner",
    "Jat",
    "Jaoli",
    "Jawhar",
    "Jintur",
    "Jiwati",
    "Jogeshwari",
    "Junnar",
    "Kagal",
    "Kaij",
    "Kalamb",
    "Kalamb",
    "Kalameshwar",
    "Kalbadevi",
    "Kalyan-Dombivli",
    "Kalamnuri",
    "Kalwan",
    "Kamptee",
    "Kandhar",
    "Kandivali",
    "Kannad",
    "Karanja",
    "Karanja",
    "Karjat",
    "Karjat",
    "Karmala",
    "Karvir",
    "Katta",
    "Katol",
    "Kavathe Mahankal",
    "Khadki",
    "Khamgaon",
    "Khanapur",
    "Khar",
    "Khalapur",
    "Khed",
    "Khed",
    "Khuldabad",
    "Kinwat",
    "Kolhapur",
    "Komna",
    "Kopargaon",
    "Korpana",
    "Koregaon",
    "Kudal",
    "Kuhi",
    "Kupwad",
    "Kurkheda",
    "Kurla",
    "Lakhandur",
    "Lakhani",
    "Lanja",
    "Latur",
    "Loha",
    "Lonar",
    "Lonavala",
    "Lohara",
    "Madha",
    "Mahabaleshwar",
    "Mahagaon",
    "Mahad",
    "Mahur",
    "Majalgaon",
    "Malad",
    "Malegaon",
    "Malegaon",
    "Malkapur",
    "Malkapur",
    "Malshiras",
    "Malvan",
    "Man",
    "Mandangad",
    "Mangalvedha",
    "Mangaon",
    "Mangrulpir",
    "Manmad",
    "Manora",
    "Mantha",
    "Manwath",
    "Maregaon",
    "Marine Lines",
    "Matunga",
    "Maval",
    "Mazgaon",
    "Mehkar",
    "Mira-Bhayandar",
    "Miraj",
    "Mohadi",
    "Mohol",
    "Mokhada",
    "Morshi",
    "Motala",
    "Mouda",
    "Mudkhed",
    "Mukhed",
    "Muktainagar",
    "Mul",
    "Mulchera",
    "Mulund",
    "Mumbai",

    "Murbad",
    "Murud",
    "Murtijapur",
    "Nagbhir",
    "Naigaon",
    "Nalwadi",
    "Nanded",
    "Nandgaon",
    "Nandgaon Khandeshwar",
    "Nandura",
    "Nandurbar",
    "Narkhed",
    "Nashik",
    "Navi Mumbai (Partially)",
    "Nawapur",
    "Ner",
    "Nevasa",
    "Nilanga",
    "Niphad",
    "Omerga",
    "Oras",
    "Osmanabad",
    "Pachora",
    "Paithan",
    "Palghar",
    "Palam",
    "Pallel",
    "Palus",
    "Pandharkawada",
    "Pandharpur",
    "Panhala",
    "Panvel",
    "Paranda",
    "Parbhani",
    "Parner",
    "Parola",
    "Partur",
    "Parli",
    "Parseoni",
    "Patan",
    "Pathardi",
    "Pathri",
    "Patur",
    "Pen",
    "Peth",
    "Phaltan",
    "Phillaur",
    "Pimpri-Chinchwad",
    "Pinguli",
    "Pipri",
    "Poladpur",
    "Pomburna",
    "Pune",
    "Purandar",
    "Purna",
    "Pusad",
    "Radhanagari",
    "Rahuri",
    "Rajapur",
    "Rajura",
    "Ralegaon",
    "Ramtek",
    "Raver",
    "Redi",
    "Renapur",
    "Risod",
    "Roha",
    "Saoner",
    "Saoli",
    "Sakoli",
    "Sakri",
    "Salekasa",
    "Sangamner",
    "Sangli",
    "Sangole",
    "Sangrampur",
    "Santacruz",
    "Satara",
    "Sawantwadi",
    "Seloo",
    "Selu",
    "Sengaon",
    "Shahada",
    "Shahapur",
    "Shahuwadi",
    "Shegaon",
    "Shevgaon",
    "Shindkheda",
    "Shirdi",
    "Shirala",
    "Shirpur",
    "Shirur",
    "Shirur-Anantpal",
    "Shirur-Kasar",
    "Shiroda",
    "Shirol",
    "Shrigonda",
    "Shrirampur",
    "Sillod",
    "Sindewahi",
    "Sindkhed Raja",
    "Sindkheda",
    "Sindi",
    "Sinnar",
    "Sironcha",
    "Soegaon",
    "Solapur",
    "Sonpeth",
    "Sudhagad",
    "Talashil",
    "Tala",
    "Taloda",
    "Telhara",
    "Teosa",
    "Thane",
    "Trimbakeshwar",
    "Tuljapur",
    "Tumsar",
    "Udgir",
    "Ulhasnagar",
    "Umarkhed",
    "Umred",
    "Umri",
    "Uran",
    "Vaijapur",
    "Valaval",
    "Vasai",
    "Velhe",
    "Vengurla",
    "Verka",
    "Vikramgad",
    "Vikhroli",
    "Vile Parle",
    "Virar",
    "Wada",
    "Wadwani",
    "Wani",
    "Warora",
    "Wardha",
    "Warud",
    "Washi",
    "Washim",
    "Yavatmal",
    "Yawal",
    "Yeola",
    "Zari Jamni"
  ],
  "Manipur": [
    "Aina",
    "Babukhal",
    "Behiang",
    "Bishnupur",
    "Borobekra",
    "Chakpikarong",
    "Chandel",
    "Chingai",
    "Churachandpur",
    "Gamgiphai",
    "Haochong",
    "Heirok",
    "Henglep",
    "Hiyanglam",
    "Imphal",
    "Imphal",
    "Jakuradhor",
    "Jiribam",
    "Jiribam",
    "Kakching",
    "Kakching",
    "Kalapahar",
    "Kamjong",
    "Kamjong",
    "Kangpokpi",
    "Kangvai",
    "Karong",
    "Kasom Khullen",
    "Kasom Khullen",
    "Keirao Bitra",
    "Khangabok",
    "Khongjom",
    "Khongsang",
    "Khoupum",
    "Khundrakpam",
    "Konthoujam",
    "Kumbi",
    "Lamka",
    "Lamphel",
    "Lamlai",
    "Lamsang",
    "Lamshang",
    "Langmeidong",
    "Langthabal",
    "Lilong",
    "Longmai",
    "Lungchong Maiphai",
    "Machi",
    "Machi",
    "Mao",
    "Maram",
    "Mayang Imphal",
    "Moirang",
    "Moreh",
    "Moreh",
    "Motbung",
    "Nambol",
    "Ningthoukhong",
    "Noney",
    "Nungba",
    "Nungba",
    "Oinam",
    "Pallel",
    "Pallel",
    "Pallel",
    "Parbung",
    "Patsoi",
    "Pherzawl",
    "Phungyar",
    "Phungyar",
    "Porompat",
    "Purul",
    "Sahamphung",
    "Samulamlan",
    "Saparmeina",
    "Sapormeina",
    "Sawombung",
    "Sekmai",
    "Senapati",
    "Singda",
    "Singhat",
    "Somdal",
    "Tadubi",
    "Taloulong",
    "Tamei",
    "Tamenglong",
    "Tangkhul",
    "Taphou",
    "Tengnoupal",
    "Thanlon",
    "Thoubal",
    "Thoubal Khunou",
    "Tipaimukh",
    "Tousem",
    "Tuibong",
    "Tujang Vaichong",
    "Ukhrul",
    "Vangai Range",
    "Wabagai",
    "Wangjing",
    "Wangoi",
    "Wangkhei",
    "Yairipok"
  ],
   "Meghalaya": [
    "Achara",
    "Adokgre",
    "Ampati",
    "Amlarem",
    "Baghmara",
    "Bajengdoba",
    "Betasing",
    "Borsora",
    "Cherrapunji",
    "Chokpot",
    "Dadenggiri",
    "Dalu",
    "Dambo Rongjeng",
    "Dawki",
    "Garobadha",
    "Gasuapara",
    "Hedul",
    "Jirang",
    "Jowai",
    "Katta",
    "Kharkutta",
    "Kharkutta",
    "Khliehriat",
    "Kudal",
    "Lad Rymbai",
    "Laskein",
    "Mahendraganj",
    "Mairang",
    "Mairang",
    "Malvan",
    "Mawkyrwat",
    "Mawkyrwat",
    "Mawlai",
    "Mawryngkneng",
    "Mawshynrut",
    "Mawsynram",
    "Mawthadraishan",
    "Mawthadraishan",
    "Mawthawpdah",
    "Mendipathar",
    "Mookaiaw",
    "Nartiang",
    "Nongkhlaw",
    "Nongkrem",
    "Nongpoh",
    "Nongpoh",
    "Nongstoin",
    "Nongstoin",
    "Nongstoin",
    "Oras",
    "Phulbari",
    "Pinguli",
    "Pynursla",
    "Rajabala",
    "Raliang",
    "Ranikor",
    "Ranikor",
    "Redi",
    "Resubelpara",
    "Riangdo",
    "Rongara",
    "Rongjeng",
    "Samanda",
    "Sawantwadi",
    "Selsella",
    "Shillong",
    "Shiroda",
    "Siju",
    "Sohra",
    "Songsak",
    "Sutnga",
    "Talashil",
    "Thadlaskein",
    "Tikrikilla",
    "Tikrikilla",
    "Tura",
    "Umroi",
    "Umsning",
    "Valaval",
    "Vengurla",
    "Williamnagar",
    "Zikzak"
  ],
  "Mizoram": [
    "Aizawl",
    "Bairabi",
    "Biate",
    "Champhai",
    "Chawngte",
    "Darlawn",
    "Hnahthial",
    "Hnahthial",
    "Khawhai",
    "Khawzawl",
    "Khawzawl",
    "Kolasib",
    "Lawngtlai",
    "Lunglei",
    "Mamit",
    "North Vanlaiphai",
    "Saiha",
    "Sairang",
    "Saitual",
    "Saitual",
    "Serchhip",
    "Thenzawl",
    "Tlabung",
    "Vairengte",
    "Zawlnuam"
  ],
  "Nagaland": [
    "Ahmedgarh",
    "Akuluto",
    "Bhandari",
    "Changtongya",
    "Chozuba",
    "Chümoukedima",
    "Chümoukedima",
    "Dera Bassi",
    "Dimapur",
    "Dimapur",
    "Jalukie",
    "Kharar",
    "Kiphire",
    "Kohima",
    "Kurali",
    "Longkhim",
    "Longleng",
    "Longleng",
    "Medziphema",
    "Mohali",
    "Mokokchung",
    "Mokokchung",
    "Mon",
    "Mon",
    "Naginimora",
    "Nawanshahr",
    "Niuland",
    "Niuland",
    "Noklak",
    "Noklak",
    "Noksen",
    "Peren",
    "Peren",
    "Phek",
    "Phek",
    "Pfutsero",
    "Shamator",
    "Shamator",
    "Seyochung",
    "Sujanpur",
    "Thonoknyu",
    "Tizit",
    "Tseminyü",
    "Tseminyü",
    "Tuensang",
    "Tuensang",
    "Wokha",
    "Wokha",
    "Zünheboto",
    "Zünheboto"
  ],
  "Odisha": [
    "Angul",
    "Asika",
    "Athgarh",
    "Athmallik",
    "Attabira",
    "Aul",
    "Balangir",
    "Balasore",
    "Balliguda",
    "Balimela",
    "Banki",
    "Bargarh",
    "Barkote",
    "Baripada",
    "Barpali",
    "Barbil",
    "Basudevpur",
    "Belpahar",
    "Bhadrak",
    "Bhawanipatna",
    "Bhuban",
    "Bhubaneswar",
    "Biramaharajpur",
    "Bissam Cuttack",
    "Boudh",
    "Brahmapur",
    "Brajarajnagar",
    "Burla",
    "Byasanagar",
    "Chhatrapur",
    "Choudwar",
    "Cuttack",
    "Damanjodi",
    "Deogarh",
    "Dhamanagar",
    "Dharamgarh",
    "Dharmasala",
    "Dhenkanal",
    "Dunguripali",
    "G.Udayagiri",
    "Gajapati",
    "Ganjam",
    "Gopalpur",
    "Gunupur",
    "Harabhanga",
    "Hinjilicut",
    "Hirakud",
    "Jagatsinghpur",
    "Jajpur",
    "Jaleswar",
    "Jatani",
    "Jeypore",
    "Jharsuguda",
    "Joda",
    "Junagarh",
    "Kalahandi",
    "Kamakshyanagar",
    "Kandhamal",
    "Kantamal",
    "Karanjia",
    "Kendrapara",
    "Kendujhar",
    "Khandapada",
    "Khariar",
    "Khordha",
    "Khordha",
    "Komna",
    "Konark",
    "Koraput",
    "Koraput",
    "Malkangiri",
    "Malkangiri",
    "Mayurbhanj",
    "Mohana",
    "Nabarangpur",
    "Nabarangpur",
    "Nayagarh",
    "Nayagarh",
    "Nilagiri",
    "Nimapada",
    "Nuapada",
    "Nuapada",
    "Odagaon",
    "Padampur",
    "Paradip",
    "Paralakhemundi",
    "Patnagarh",
    "Pattamundai",
    "Phulbani",
    "Puri",
    "Puri",
    "Purushottampur",
    "R.Udayagiri",
    "Raighar",
    "Rajagangapur",
    "Rairangpur",
    "Rayagada",
    "Rayagada",
    "Reamal",
    "Rourkela",
    "Sambalpur",
    "Sambalpur",
    "Sonepur",
    "Soro",
    "Subarnapur",
    "Sunabeda",
    "Sundargarh",
    "Sundargarh",
    "Talcher",
    "Tirtol",
    "Titilagarh",
    "Umerkote"
  ],
  "Puducherry": [
    "Ambagarathur",
    "Ariyankuppam",
    "Bahour",
    "Chalakkara",
    "Guirepalli",
    "Kalapet",
    "Kanakalapeta",
    "Karaikal",
    "Karaikal",
    "Kottucherry",
    "Kurumbapet",
    "Lawspet",
    "Mahe",
    "Mahe",
    "Manavely",
    "Mettakur",
    "Muthialpet",
    "Nedungadu",
    "Oulgaret",
    "Palloor",
    "Pandakkal",
    "Puducherry",
    "Puducherry",
    "Reddiarpalayam",
    "T.R. Pattinam",
    "Thirunallar",
    "Varichikudi",
    "Villianur",
    "Yanam",
    "Yanam"
  ],
  "punjab": [
    "Abohar",
    "Adampur",
    "Ahmedgarh",
    "Ahmedgarh",
    "Ajnala",
    "Alawalpur",
    "Amargarh",
    "Amloh",
    "Amritsar",
    "Anandpur Sahib",
    "Attari",
    "Bagha Purana",
    "Bajwara",
    "Balachaur",
    "Banga",
    "Barnala",
    "Bassi Pathana",
    "Batala",
    "Beas",
    "Begowal",
    "Bhagta Bhai Ka",
    "Bhawanigarh",
    "Bhikhiwind",
    "Bhogpur",
    "Budha Theh",
    "Budhlada",
    "Chabbewal",
    "Chamkaur Sahib",
    "Chohla Sahib",
    "Dasuya",
    "Dera Baba Nanak",
    "Dera Bassi",
    "Dhariwal",
    "Dharamkot",
    "Dhilwan",
    "Dhuri",
    "Dina Nagar",
    "Dirba",
    "Doraha",
    "Faridkot",
    "Fatehgarh Churian",
    "Fatehgarh Sahib",
    "Fazilka",
    "Ferozepur",
    "Garhdiwala",
    "Garhshankar",
    "Ghanaur",
    "Gidderbaha",
    "Gobindgarh",
    "Goniana",
    "Goraya",
    "Gurdaspur",
    "Guru Har Sahai",
    "Handiaya",
    "Hariana",
    "Harike",
    "Hoshiarpur",
    "Hussainpur",
    "Jagraon",
    "Jaitu",
    "Jalandhar",
    "Jalalabad",
    "Jandiala Guru",
    "Kahnuwan",
    "Kapurthala",
    "Kartarpur",
    "Khem Karan",
    "Khanna",
    "Kharar",
    "Kot Ise Khan",
    "Kotkapura",
    "Kurali",
    "Kupwad",
    "Lehragaga",
    "Lohian Khas",
    "Longowal",
    "Ludhiana",
    "Machhiwara",
    "Majitha",
    "Makhu",
    "Malerkotla",
    "Mallanwala",
    "Maloud",
    "Malout",
    "Mansa",
    "Moga",
    "Moonak",
    "Morinda",
    "Mukerian",
    "Muktsar",
    "Mullanpur Dakha",
    "Nabha",
    "Nangal",
    "Nakodar",
    "Narot Jaimal Singh",
    "Nawanshahr",
    "Nihal Singh Wala",
    "Nurmahal",
    "Pathankot",
    "Patiala",
    "Patti",
    "Payal",
    "Phagwara",
    "Phillaur",
    "Qadian",
    "Raikot",
    "Rajasansi",
    "Rajpura",
    "Ramdas",
    "Rampura Phul",
    "Rupnagar",
    "Sahnewal",
    "Samana",
    "Samrala",
    "Sangat",
    "Sangrur",
    "Sardulgarh",
    "Sarhali",
    "SAS Nagar (Mohali)",
    "Satara",
    "Shaheed Bhagat Singh Nagar",
    "Shahkot",
    "Sham Chaurasi",
    "Shutrana",
    "Sirhind",
    "Sri Muktsar Sahib",
    "Sujanpur",
    "Sultanpur Lodhi",
    "Sunam",
    "Talwandi Bhai",
    "Tanda",
    "Tapa",
    "Tarn Taran",
    "Tarn Taran Sahib",
    "Verka",
    "Zira"
  ],
  
  "Rajasthan": [
    "Abu Road", "Ahore", "Ajmer", "Aklera", "Alwar", "Amet", "Anta", "Aravalli", "Asind", "Bagar", "Bali", "Balotra", "Banswara", "Baran", "Bari", "Bari Sadri", "Barmer", "Basni", "Bayana", "Baytoo", "Beawar", "Begun", "Behror", "Bhadra", "Bhawani Mandi", "Bhilwara", "Bhinmal", "Bichhiwara", "Bikaner", "Bilara", "Bissau", "Bundi", "Chaksu", "Chhabra", "Chhipabarod", "Chhoti Sadri", "Chittorgarh", "Churu", "Deeg", "Deogarh", "Deshnoke", "Dhaban", "Dholpur", "Didwana", "Dudu", "Dungargarh", "Dungarpur", "Fatehpur", "Gadra Road", "Gangapur", "Gangapur City", "Ghatol", "Gulabpura", "Hanumangarh", "Hindaun", "Jahazpur", "Jaisalmer", "Jaitaran", "Jalore", "Jhalawar", "Jhunjhunu", "Jodhpur", "Kaman", "Kapasan", "Karauli", "Kekri", "Keshoraipatan", "Ketu", "Khanpur", "Kherli", "Kishangarh", "Kota", "Kotputli", "Kumbhalgarh", "Kushalgarh", "Lachhmangarh", "Ladnun", "Lakheri", "Lalsot", "Luni", "Makrana", "Malpura", "Mandalgarh", "Mandawar", "Mangrol", "Marwar Junction", "Merta City", "Mount Abu", "Nadbai", "Nagaur", "Nainwa", "Nasirabad", "Nathdwara", "Neem Ka Thana", "Nimbahera", "Niwai", "Nohar", "Nokha", "Osian", "Pachpadra", "Pachpahar", "Pali", "Partapur", "Phalodi", "Phulera", "Pirawa", "Pokhran", "Pratapgarh", "Pushkar", "Raipur", "Rajakhera", "Rajaldesar", "Rajgarh", "Rajsamand", "Ratangarh", "Rawatbhata", "Rawatsar", "Rishabhdeo", "Sadri", "Sagwara", "Salumbar", "Sanchore", "Sangaria", "Sangod", "Sardarshahar", "Sarwar", "Sawai Madhopur", "Shahpura", "Sheoganj", "Sikar", "Sirohi", "Siwana", "Sojat", "Sri Ganganagar", "Sri Madhopur", "Sujangarh", "Sumerpur", "Suratgarh", "Takhatgarh", "Taranagar", "Thanagazi", "Tibbi", "Tijara", "Todabhim", "Tonk", "Udaipur", "Uniara", "Vallabhnagar", "Vijainagar", "Viratnagar", "Weir"
  ],

  "Sikkim": [
    "Chungthang", "Gangtok", "Gyalshing", "Jorethang", "Kaluk", "Lachen", "Lachung", "Mangan", "Namchi", "Pakyong", "Pelling", "Ravangla", "Rongli", "Rorathang", "Singtam", "Soreng", "Yuksom"
  ],

  "Tamil Nadu": [
    "Abu Road", "Ammoor", "Arakkonam", "Arani", "Ariyalur", "Arni", "Attur", "Chengalpattu", "Chennai", "Cheyyar", "Chidambaram", "Coimbatore", "Coonoor", "Cuddalore", "Dharmapuri", "Dindigul", "Erode", "Gingee", "Gobichettipalayam", "Gudalur", "Gudiyatham", "Hosur", "Jayankondam", "Kallakurichi", "Kancheepuram", "Karaikudi", "Karur", "Kodaikanal", "Kovilpatti", "Krishnagiri", "Kumbakonam", "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal", "Neyveli", "Nilgiris", "Ooty", "Palani", "Palladam", "Pattukkottai", "Pollachi", "Pudukkottai", "Rajapalayam", "Ramanathapuram", "Ranipet", "Salem", "Sankarankovil", "Sathyamangalam", "Sivaganga", "Sivakasi", "Sriperumbudur", "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Tindivanam", "Tiruchirappalli", "Tirunelveli", "Tirupathur", "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Tiruvottiyur", "Tuticorin", "Udumalpet", "Ulundurpet", "Valparai", "Vandavasi", "Vaniyambadi", "Vellore", "Viluppuram", "Virudhunagar", "Yercaud"
  ],

  "Telangana": [
    "Adilabad", "Asifabad", "Bhadrachalam", "Bhupalpally", "Bodhan", "Choutuppal", "Gadwal", "Hyderabad", "Jagtial", "Jangaon", "Jayashankar", "Kamareddy", "Karimnagar", "Khammam", "Kothagudem", "Mahabubabad", "Mahabubnagar", "Mancherial", "Medak", "Medchal", "Miryalaguda", "Nagarkurnool", "Nalgonda", "Nirmal", "Nizamabad", "Peddapalli", "Rajanna", "Rangareddy", "Sangareddy", "Siddipet", "Suryapet", "Vikarabad", "Wanaparthy", "Warangal", "Yadadri"
  ],

  "Tripura": [
    "Agartala", "Ambassa", "Amarpur", "Belonia", "Dharmanagar", "Kailashahar", "Kamalpur", "Khowai", "Sabroom", "Udaipur"
  ],

  "Uttar Pradesh": [
    "Agra", "Aligarh", "Allahabad", "Ambedkar Nagar", "Amethi", "Amroha", "Auraiya", "Ayodhya", "Azamgarh", "Baghpat", "Bahraich", "Ballia", "Balrampur", "Banda", "Barabanki", "Bareilly", "Basti", "Bhadohi", "Bijnor", "Budaun", "Bulandshahr", "Chandauli", "Chitrakoot", "Deoria", "Etah", "Etawah", "Faizabad", "Farrukhabad", "Fatehpur", "Firozabad", "Gautam Buddha Nagar", "Ghaziabad", "Ghazipur", "Gonda", "Gorakhpur", "Hamirpur", "Hapur", "Hardoi", "Hathras", "Jalaun", "Jaunpur", "Jhansi", "Kannauj", "Kanpur Dehat", "Kanpur Nagar", "Kasganj", "Kaushambi", "Kheri", "Kushinagar", "Lalitpur", "Lucknow", "Maharajganj", "Mahoba", "Mainpuri", "Mathura", "Mau", "Meerut", "Mirzapur", "Moradabad", "Muzaffarnagar", "Pilibhit", "Pratapgarh", "Raebareli", "Rampur", "Saharanpur", "Sambhal", "Sant Kabir Nagar", "Shahjahanpur", "Shamli", "Shravasti", "Siddharthnagar", "Sitapur", "Sonbhadra", "Sultanpur", "Unnao", "Varanasi"
  ],

  "Uttarakhand": [
    "Almora", "Bageshwar", "Chamoli", "Champawat", "Dehradun", "Haridwar", "Nainital", "Pauri Garhwal", "Pithoragarh", "Rudraprayag", "Tehri Garhwal", "Udham Singh Nagar", "Uttarkashi"
  ],

  "West Bengal": [
    "Alipurduar", "Asansol", "Bankura", "Bardhaman", "Barrackpore", "Basirhat", "Berhampore", "Bishnupur", "Cooch Behar", "Darjeeling", "Durgapur", "English Bazar", "Haldia", "Howrah", "Jalpaiguri", "Jhargram", "Kalimpong", "Kharagpur", "Kolkata", "Krishnanagar", "Malda", "Medinipur", "Nadia", "Purulia", "Raiganj", "Siliguri", "Suri"
  ]

};

export default indianStatesAndCities;



  